import useUserStore from "@/state/user/useUserStore";
import { useCallback, useEffect } from "react";

export const useBackHandler = () => {
  const [
    selectedImage,
    setSelectedImage,
    uploadedImage,
    setUploadedImage,
    setAssets,
    setTabs,
    setFlipImage,
    setImageFormat,
    textFields,
    removeTextField,
    setRestrictedFonts,
    setRatio,
    imageFormat,
    setUploadedAssets,
    setLocal,
  ] = useUserStore((state) => [
    state.selectedImage,
    state.setSelectedImage,
    state.uploadedImage,
    state.setUploadedImage,
    state.setAssets,
    state.setTabs,
    state.setFlipImage,
    state.setImageFormat,
    state.textFields,
    state.removeTextField,
    state.setRestrictedFonts,
    state.setRatio,
    state.imageFormat,
    state.setUploadAssets,
    state.setLocal,
  ]);

  const backHandler = useCallback(() => {
    if (selectedImage || uploadedImage) {
      setLocal(false);
      setImageFormat(null);
      setSelectedImage("");
      setUploadedImage("");
      setAssets([]);
      setTabs("project");
      textFields.forEach((field) => {
        removeTextField(field.id);
      });
      setRestrictedFonts([]);
      setFlipImage(false);
      setRatio("1");
      setUploadedAssets([]);
    } else {
      setLocal(false);
      setImageFormat(null);
    }
  }, [
    selectedImage,
    uploadedImage,
    setImageFormat,
    setSelectedImage,
    setUploadedImage,
    setAssets,
    setTabs,
    textFields,
    removeTextField,
    setRestrictedFonts,
    setFlipImage,
    setRatio,
    setUploadedAssets,
    setLocal,
  ]);

  return backHandler;
};
